import styled from 'styled-components';

export const StyledImageGallery = styled.div`
  margin-left: auto;
  margin-right: auto;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  width: 75%;
  max-width: 75%;

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
